import React from "react";
import { scrollToId } from "../utils/scroll";

function Hero() {
  const goTo = (id) => (e) => {
    e.preventDefault();
    scrollToId(id);
  };

  return (
    <section id="home" className="hero">
      <div className="container hero__inner">
        <div>
          <p className="hero__motto">Per Ardua Ad Astra</p>
          <h1>
            Warwickshire <em>Royal Air Force</em> Lodge No. 9456
          </h1>
          <p className="hero__lead">
            A Freemasons' Lodge under the United Grand Lodge of England, founded in 1992
            by RAF veterans — open to all who served, and to all those who share an interest in aviation.
          </p>
          <div className="hero__cta">
            <a className="btn" href="#about" onClick={goTo("about")}>
              Learn about the lodge{" "}
              <span className="arrow" aria-hidden="true">→</span>
            </a>
            <a className="btn btn--ghost" href="#contact" onClick={goTo("contact")}>
              Register interest
            </a>
          </div>
          <dl className="hero__meta">
            <div>
              <dt>Consecrated</dt>
              <dd>1992</dd>
            </div>
            <div>
              <dt>Constitution</dt>
              <dd>UGLE</dd>
            </div>
            <div>
              <dt>Province</dt>
              <dd>Warwickshire</dd>
            </div>
            <div>
              <dt>Meet at</dt>
              <dd>Knowle Masonic Centre</dd>
            </div>
          </dl>
        </div>
        <div className="hero__crest" aria-hidden="true">
          <img src="/images/raf9456logo.png" alt="" />
          <div className="hero__crest__motto">EST · MCMXCII</div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
